import { styled } from '@frontend/theme';
import { Box as MUIBox } from '@mui/material';

export const LoginFormBox = styled(MUIBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '16px 24px',
  maxWidth: '604px',
  backgroundColor: theme.palette.common.white,

  width: '100%',
  [theme.breakpoints.down('tablet')]: {
    maxWidth: '332px',
  },

  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    width: '100%',
    '& > .MuiTextField-root': {
      width: '100%',
    },
    '& > .MuiButton-root': {
      width: '100%',
    },
    '& > p': {
      fontWeight: '500',
    },
  },
}));
